import SessionTypes from './SessionTypes';

export function login ({ email, password, rememberMe }) {
  return {
    type: SessionTypes.LOG_IN_REQUEST,
    payload: {
      email,
      password,
      rememberMe
    }
  };
}

export function loginOTP (payload) {
  return {
    type: SessionTypes.LOGIN_OTP_REQUEST,
    payload: payload
  };
}

export function logout () {
  return {
    type: SessionTypes.LOG_OUT
  };
}

export function cacheRoutePath () {
  return {
    type: SessionTypes.CACHE_PREV_LOGIN_ROUTE
  };
}

export function checkActivity () {
  return {
    type: SessionTypes.CHECK_ACTIVITY
  };
}
